import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e7168bd2")

_pushScopeId("data-v-e7168bd2")
const _hoisted_1 = {
  key: 0,
  class: "hotspot-module-container"
}
const _hoisted_2 = { class: "cover-wrapper" }
const _hoisted_3 = { class: "top-wrapper" }
const _hoisted_4 = { class: "top-wrapper-image" }
const _hoisted_5 = { class: "top-wrapper-intro" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ImgContainer = _resolveComponent("ImgContainer")
  const _component_HotspotContentList = _resolveComponent("HotspotContentList")
  const _component_HotspotLogoTips = _resolveComponent("HotspotLogoTips")

  return (_ctx.modules)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("span", null, _toDisplayString(_ctx.modules.top.title), 1),
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_ImgContainer, {
                src: _ctx.modules.top.cover
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_5, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.top.intro, (i, k) => {
                return (_openBlock(), _createBlock("p", { key: k }, _toDisplayString(i), 1))
              }), 128))
            ])
          ]),
          _createVNode(_component_HotspotContentList, {
            list: _ctx.modules.list,
            onAudiobgstop: _ctx.audiobgstop
          }, null, 8, ["list", "onAudiobgstop"]),
          _createVNode(_component_HotspotLogoTips, {
            text: _ctx.modules.logoTips,
            onAction: _ctx.goZsPage
          }, null, 8, ["text", "onAction"])
        ])
      ]))
    : _createCommentVNode("", true)
})